const gioitinh = {
  nam: 1,
  nu: 2,
  khac: 3,
}
const mapGioiTinh = (value = '') => {
  switch (value.toLowerCase()) {
    case 'nam':
      return gioitinh.nam
    case 'nữ':
      return gioitinh.nu
    case 'khác':
      return gioitinh.khac
    default:
      return 0
  }
}

const getGioiTinh = (value = 0) => {
  switch (value) {
    case gioitinh.nam:
      return 'Nam'
    case gioitinh.nu:
      return 'Nữ'
    case gioitinh.khac:
      return 'Khác'
    default:
      return ''
  }
}
export default gioitinh
export { mapGioiTinh, getGioiTinh }
